import { Component, Prop, Vue } from "vue-property-decorator";
import postModule from '../../../store/modules/post.module';
import DxTextBox from 'devextreme-vue/text-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import { DxValidator, DxRequiredRule } from 'devextreme-vue/validator';
import DxButton from 'devextreme-vue/button';
import { Post } from "@/shared/dtos/post";
import { confirm } from 'devextreme/ui/dialog';
import { itiMessageService } from "@/iti-core-vue";

@Component({
  components: {
    DxTextBox,    
    DxTextArea,
    DxValidator,
    DxRequiredRule,
    DxValidationSummary,
    DxButton,
  }
})
export default class ForumFormulario extends Vue {
  @Prop() public ambitId!: number;
  public post: Post = new Post();

  public created() {
    this.post = postModule.editPost;
    postModule.postToEdit(new Post());
  }

  public save() {
    if(this.post.id == null) {
      itiMessageService.confirm('¿Está seguro de que desea guardar este post?', this.$tc('mensajes.confirmar'), (result) => {
        if(result) {
          var post: Post = new Post();
          post.title = this.post.title;
          post.content = this.post.content;
          post.ambitId = this.ambitId;
          postModule.savePost(post)
            .then(() => {this.close(); itiMessageService.toast('Respuesta guardada con exito', 'success', 2000)})
            .catch(() => itiMessageService.toast('No se ha podido crear el post', 'error', 2000));
        }
      }); 
    }
    else {
      itiMessageService.confirm('¿Está seguro de que desea editar este post?', this.$tc('mensajes.confirmar'), (result) => {
        if(result) {
          var post: Post = new Post(this.post);
          post.title = this.post.title;
          post.content = this.post.content;
          postModule.updatePost(post)
            .then(() => {this.close(); itiMessageService.toast('Post editado con exito', 'success', 2000)})
            .catch(() => itiMessageService.toast('No se ha podido editar el post', 'error', 2000));
        }
      });
    }
  }

  public close() {
    this.$router.back();
  }
}
